var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var BlogCategories = function(el) {
  var t = this;
  t.$picker = $( '.blog-menu--mobile' );

  t.$picker.on('change', 'select', function(event) {
    var url = event.target.value;
    if (url) {
      window.location.href = url;
    }
  }.bind(this));
};

module.exports = BlogCategories;
